var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85363 4.14645C7.65837 3.95118 7.34178 3.95118 7.14652 4.14645L4.14652 7.14645L3.79297 7.5L4.50008 8.20711L4.85363 7.85355L7 5.70718V16.5V17H8V16.5V5.70703L10.1465 7.85355L10.5001 8.20711L11.2072 7.5L10.8536 7.14645L7.85363 4.14645ZM13.5001 15.7929L13.8536 16.1464L16.0001 18.2929V7.5V7H17.0001V7.5V18.2929L19.1465 16.1464L19.5001 15.7929L20.2072 16.5L19.8536 16.8536L16.8536 19.8536C16.6584 20.0488 16.3418 20.0488 16.1465 19.8536L13.1465 16.8536L12.793 16.5L13.5001 15.7929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e78e5883d10a7d15edd9e701c2c912b6.svg";
export { ForwardRef as ReactComponent };